var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"ml-0 mr-2 font-weight-bold white--text",attrs:{"color":_vm.color,"label":"","x-small":""}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }